module.exports = "<div class=\"quote {{ ctrl.quoteClass }}\">\n\n  <div ng-if=\"ctrl.loading\" class=\"quote-loading\">\n    <h1 ng-show=\"!ctrl.isFetchingPage\">One moment please while we retrieve your quote...</h1>\n    <img src=\"/static/images/ring.gif\"/>\n  </div>\n\n  <div ng-if=\"ctrl.error\" ng-include=\"ctrl.errorTemplate\"></div>\n\n  <div ng-if=\"!ctrl.loading && !ctrl.error && ctrl.template\" ng-include=\"ctrl.template\"></div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/partials/quote.html
// module id = 318
// module chunks = 0